import React from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import styles from "./discover-now.module.css";
import { Trans, useTranslation } from "@coworker/locales";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { UpptackaSetUpInfo } from "./UpptackaSetupInfo";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import trackerHelper from "@coworker/app/src/helpers/tracker";

interface DiscoverNowSheetProps {
  tileName: string;
  imageUrl: string;
  isSheetOpen: boolean;
  setIsSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DiscoverNowSheet = ({
  tileName,
  imageUrl,
  isSheetOpen,
  setIsSheetOpen,
}: DiscoverNowSheetProps) => {
  const { t } = useTranslation();
  const navigate = useFixaNavigate();
  return (
    <FixaModal
      handleCloseBtn={() => setIsSheetOpen(!isSheetOpen)}
      visible={isSheetOpen}
      focusLockProps={{
        locked: false,
      }}
      keepContentMounted={true}
    >
      <FixaSheets
        labelledById="home-discover-now-modal-header"
        alignment="right"
        footer={
          <FixaModalFooter className={styles["footer"] as string}>
            <FixaButton
              type="primary"
              text={<Trans>createString</Trans>}
              onClick={() => {
                navigate("/task/new/custom");
                trackerHelper.trackUpptackaCreateTaskClick();
              }}
            />
          </FixaModalFooter>
        }
        header={
          <FixaModalHeader
            id="home-discover-now-modal-header"
            ariaCloseTxt={t("closeDiscoverNowString")}
            title={t("discoverNowString")}
          />
        }
      >
        <FixaImage src={imageUrl} fallback={true} />
        <FixaModalBody>
          <div className={styles["sheet-title"]}>
            <Trans values={{ tile: tileName }}>tileNameInUpptackaString</Trans>
          </div>
          <div className={styles["set-up"]}>
            <Trans>upptackaSetUpString</Trans>
          </div>
          <UpptackaSetUpInfo />
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
